import { IError } from '../../interfaces';

export function toInteger(value: any): number {
  return parseInt(`${value}`, 10);
}

export function toString(value: any): string {
  return value !== undefined && value !== null ? `${value}` : '';
}

export function getValueInRange(value: number, max: number, min = 0): number {
  return Math.max(Math.min(value, max), min);
}

export function isString(value: any): value is string {
  return typeof value === 'string';
}

export function isNumber(value: any): value is number {
  return !isNaN(toInteger(value));
}

export function isInteger(value: any): value is number {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}

export function isDefined(value: any): boolean {
  return value !== undefined && value !== null;
}

export function padNumber(value: number): string {
  if (isNumber(value)) {
    return `0${value}`.slice(-2);
  }
  return '';
}

export function regExpEscape(text): string {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}

export function hasClassName(element: any, className: string): boolean {
  return element && element.className && element.className.split && element.className.split(/\s+/).indexOf(className) >= 0;
}

export function groupBy(target, funcProp): void {
  return target.reduce((acc, val) => {
    (acc[funcProp(val)] = acc[funcProp(val)] || []).push(val);
    return acc;
  }, {});
}

export function uniqBy(target, key): void {
  const seen = {};
  return target.filter((item) => {
    const k = key(item);
    return seen.hasOwnProperty(k) ? false : (seen[k] = true);
  });
}

export function camelToSnake(value: string): string {
  if (value) {
    const parsed = value.replace(/(?:^|\.?)([A-Z])/g, (x, y) => `_${y.toLowerCase()}`).replace(/^_/, '');
    return parsed;
  }
  // TODO Error a config
  throw { message: `camelToSnake: provided_value_not_valid` } as IError;
}

export function camelToKebab(value: string): string {
  if (value) {
    const parsed = value.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase();
    return parsed;
  }
  // TODO Error a config
  throw { message: `camelToKebab: provided_value_not_valid` } as IError;
}

export function pascalToKebab(value: string): string {
  if (value) {
    value = firstLetterLower(value);
    const parsed = value.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase();
    return parsed;
  }
  // TODO Error a config
  throw { message: `camelToKebab: provided_value_not_valid` } as IError;
}

export function firstLetterUpper(value: string): string {
  if (value && typeof value === 'string') {
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
  return value;
}

export function firstLetterLower(value: string): string {
  if (value && typeof value === 'string') {
    return value.charAt(0).toLocaleLowerCase() + value.slice(1);
  }
  return value;
}

export function capitalizeText(value: string): string {
  if (value && typeof value === 'string') {
    return value.replace(/(?:^|\s|["'([{])+\S/g, (match) => match.toUpperCase());
  }
  return value;
}

export function isEquivalent(a: { [key: string]: any }, b: { [key: string]: any }) {
  const aProps = Object.getOwnPropertyNames(a);
  const bProps = Object.getOwnPropertyNames(b);
  if (aProps.length !== bProps.length) {
    return false;
  }
  for (let i = 0; i < aProps.length; i++) {
    const propName = aProps[i];
    if (a[propName] !== b[propName]) {
      return false;
    }
  }
  return true;
}

/**
 * Function to format date to set excel fileName
 * Input format: yyyy/mm/dd
 * Output format: dd_mm_yyyy
 * @param date Date to format
 */
export function excelExportDateFormat(date: string, isParams: boolean = false): string {
  const datePart = date.split('/');

  const year = datePart[0];
  const month = datePart[1];
  const day = datePart[2];
  if (isParams) {
    return `${year}-${month}-${day}`;
  }
  return `${day}_${month}_${year}`;
}
